import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { type UiEngagementSpec } from 'Pages/combinedFilterFormPage/filterConditionTypes'
import EngagementIcon from './EngagementIcon'

const StyledLI = styled.li`
  min-height: 18px;
  display: flex;
  justify-content: stretch;
  align-items: center;
  padding: 5px 10px;
  margin: 0;
  font-size: 13px;
  line-height: 1.3;

  color: #7c7c7c;
  cursor: pointer;
  align-items: flex-start;

  gap: 8px;

  &[data-focus='true'] {
    background: var(--wild-sand);
  }

  &[data-selected='true'] {
    color: var(--silver);
  }

  &[data-disabled='true'] {
    color: var(--silver);
    cursor: default;
  }

  &[data-disabled='true'][data-focus='true'] {
    background: none;
  }

  &[data-loading='true'] {
    pointer-events: none;
    opacity: 0.5;
    color: inherit;
    background: none;
  }

  &:focus {
    outline: none;
  }
`

interface Option {
  label: string
  value: UiEngagementSpec['Value']
  disabled: boolean
  selected: boolean
}

interface EngagementOptionProps {
  focus: boolean
  loading: boolean
  onMouseEnter: () => void
  option: Option
  optionIndex: number
  onSelect: (o: Option) => void
}

const EngagementOption: FC<EngagementOptionProps> = ({
  focus,
  loading,
  onMouseEnter,
  option,
  optionIndex,
  onSelect,
}) => {
  const handleClick: React.MouseEventHandler<HTMLLIElement> = () => {
    if (option.disabled || loading) {
      return
    }
    onSelect(option)
  }

  return (
    <StyledLI
      tabIndex={0}
      onClick={handleClick}
      onMouseOver={onMouseEnter}
      onMouseEnter={onMouseEnter}
      data-mu-test={`select__option ${option.value}`}
      data-mu-option-index={optionIndex}
      data-focus={focus}
      data-selected={option.selected}
      data-disabled={option.disabled}
    >
      {option.value !== null && option.value !== undefined && (
        <EngagementIcon score={option.value} />
      )}

      <span>{option.label}</span>
    </StyledLI>
  )
}

export default EngagementOption
